export default __webpack_public_path__ + "static/media/8.1.787ddc73.png";